import { RouterMap } from '../../types';

export const routeMap: RouterMap = new Map();

routeMap.set('/fittingsMachine/deliverGoods', {
  name: 'DeliverGoods',
  meta: {
    nav: [
      { id: '150', title: '待申请' },
      { id: '160', title: '已申请待发货' },
      { id: '170', title: '发货待全部签收' },
      { id: '180', title: '全部签收' },
      { id: '190', title: '发货驳回' },
      { id: '200', title: '配件停滞' },
    ],
  },
});
routeMap.set('/fittingsMachine/returnRetrieve', {
  name: 'ReturnRetrieve',
  meta: {
    nav: [
      { id: '220', title: '待返件' },
      { id: '230', title: '待全部签收' },
      { id: '240', title: '全部签收' },
      { id: '250', title: '待处理异常' },
    ],
  },
});
routeMap.set('/fittingsMachine/expendManage', {
  name: 'ExpendManage',
});
routeMap.set('/fittingsMachine/purchaseAccessories', {
  name: 'PurchaseAccessories',
});
routeMap.set('/fittingsMachine/partsReturn', {
  name: 'PartsReturn',
});
routeMap.set('/fittingsMachine/salesAccessories', {
  name: 'SalesAccessories',
});
routeMap.set('/fittingsMachine/returningFactory', {
  name: 'ReturningFactory',
  meta: {
    nav: [
      { id: '280', title: '待返厂' },
      { id: '290', title: '无返厂任务新件' },
      { id: '300', title: '待拣货发货' },
      { id: '310', title: '已返厂' },
      { id: '320', title: ' 已作废' },
      { id: '330', title: ' 核销驳回' },
    ],
  },
});
routeMap.set('/fittingsMachine/allocateTransfer', {
  name: 'AllocateTransfer',
});

routeMap.set('/fittingsMachine/returnAbnormal', {
  name: 'ReturnAbnormal',
  meta: {
    nav: [
      { id: '260', title: '待处理' },
      { id: '270', title: '已处理' },
    ],
  },
});